// ── Channel / PDM ──────────────────────────────────────────────────────────
export const CHANNEL_COUNT = 8;

// ── Battery ────────────────────────────────────────────────────────────────
export const BATTERY_CAPACITY_AH  = 200;
export const SOC_WARNING_DEFAULT  = 20;   // %
export const SOC_WARNING_MIN      = 5;    // %
export const SOC_WARNING_MAX      = 50;   // %
export const SOC_WARNING_STEP     = 5;    // %

// ── Timing: app shell ──────────────────────────────────────────────────────
export const TAB_FADE_MS            = 120;  // tab cross-fade transition
export const OVERLAY_TRANSITION_MS  = 300;  // slide-in/out CSS transition (matches duration-300)
export const OVERLAY_CLEAR_DELAY_MS = OVERLAY_TRANSITION_MS + 20; // clear data after slide-out completes

// ── Timing: discovery & network ────────────────────────────────────────────
export const DISCOVERY_DELAY_MS       = 450;   // mock network scan latency
export const GATEWAY_SCAN_DURATION_MS = 3200;  // BLE scan window
export const GATEWAY_STAGGER_MS       = 220;   // stagger between discovered gateway tiles
export const SCAN_DOT_INTERVAL_MS     = 400;   // scanning dots animation interval

// ── Timing: gateway connection ─────────────────────────────────────────────
export const CONNECT_ANIMATION_MS    = 900;
export const DISCONNECT_ANIMATION_MS = 700;

// ── Timing: firmware update ────────────────────────────────────────────────
export const FIRMWARE_UPDATE_DURATION_MS = 5000;
